var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg8(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "wbsvg",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 30",
    width: 25,
    height: 50,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    fill: "#000000",
    strokeWidth: 0,
    d: "M9 6 L7 6 L10 2 L13 6 L11 6 L11 25 L2 25 L2 24 L9 24 L9 23 L2 23 L2 22 L9 22 L9 21 L2 21 L2 20 L9 20 L9 19 L5 19 L5 18 L9 18Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg8);
export default __webpack_public_path__ + "static/media/8.1c1c535fd5dbebd2be4cad6ddefcd0c6.svg";
export { ForwardRef as ReactComponent };